import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import getters from './getters';
import configs from './modules/configs';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    configs,
  },
  state: {},
  mutations: {},
  actions: {},
  getters,
});
